import * as React from 'react';
import { Button } from 'antd';
import { useMutation } from '@apollo/client';
import { regexPhoneNumber } from '../../../utils/commons';
import InputField from '../components/InputField';
import { TLoginResult, TUserLoginInput, USER_LOGIN } from '../../../graphql/schema';
import { LOGIN_PASSWORD_TITLE, LOGIN_PHONE_NUMBER_TITLE, LOGIN_WRONG_PHONE_ERROR_TEXT } from '../../../common/constants';
import PasswordInput from '../components/PasswordInput';
import { TUserLoginContext, useAuth } from '../../../context/AuthContext';

interface ILoginFormProps {
}

const LoginForm: React.FunctionComponent<ILoginFormProps> = (props) => {
  const [phone, setPhone] = React.useState<string>('')
  const [password, setPassword] = React.useState<string>('')
  const [hasPhoneValue, setHasPhoneValue] = React.useState<boolean>(false)
  const [hasPasswordValue, setHasPasswordValue] = React.useState<boolean>(false)
  const [isError, setIsError] = React.useState<boolean>(false)
  const [login] = useMutation<TLoginResult, TUserLoginInput>(USER_LOGIN);
  const authContext = useAuth();
  const onChangePhone = (v: string) => {
    setPhone(v)
  }

  const onChangePassword = (v: string) => {
    setPassword(v)
  }
  React.useMemo(() => {
    setHasPhoneValue(phone.length > 0)
  }, [phone])
  React.useMemo(() => {
    setHasPasswordValue(password.length > 0)
  }, [password])

  const onClick = async () => {
    if (!regexPhoneNumber(phone)) {
      setIsError(true);
      setHasPhoneValue(false)
      return
    }
    setIsError(false);
    const accountLogin = {
      phoneNumber: phone,
      password: password,
    }
    const loginReturnData = await login({
      variables: {
        input: accountLogin
      },
    });
    const result = loginReturnData.data?.userLogin;
    if (result) {
      const user: TUserLoginContext = {
        user: result.user,
        accessToken: result.accessToken,
        accountLogin: accountLogin,
      }
      authContext?.setUserInfo(user)
    }
  }
  return <div className='flex flex-1'>
    <div className='mt-[2rem] flex flex-col flex-1 gap-[0.5rem]'>
      <InputField title={LOGIN_PHONE_NUMBER_TITLE} isError={isError} hasValue={hasPhoneValue} onChangeValue={onChangePhone} errorText={LOGIN_WRONG_PHONE_ERROR_TEXT} />
      <PasswordInput title={LOGIN_PASSWORD_TITLE} hasValue={hasPasswordValue} onChangeValue={onChangePassword} />
      <div>
        <Button className='w-full mt-[1.5rem] h-[4rem] rounded-[0px] bg-blue-Primary text-[22px] font-6 leading-[32px] !text-neutral-White disabled:bg-blue-shade' disabled={!(hasPasswordValue && hasPhoneValue)} onClick={onClick}>Đăng nhập</Button>
      </div>
    </div>
  </div>;
};

export default LoginForm;
